<template>
  <div>
    <div class="app-header flex-x-center flex-space-between">
      <!-- <div class="icoBack" @click.stop.prevent='backBtn'/> -->
      <img src="@/assets/img/bi_order_app_v.png" class="app-header-bi">
      <div class="icoHome" @click="appMoveMain()"/>
    </div>
    <BottomMenu/>
  </div>
</template>
<script>
import BottomMenu from '@/components/App/BottomMenu.vue'

export default {
  components: {
    BottomMenu
  },
  data () {
    return {

    }
  },
  beforeDestroy () {
    document.querySelector('html').removeAttribute('style')
  },
  mounted () {
    window.backBtn = () => {
      this.appMoveMain()
    }
    document.querySelector('html').style.backgroundColor = 'transparent'
  },
  methods: {

  }
}
</script>

<style scoped>
</style>
